"use client";

import { clearDemoMode } from "./actions";
import type { DemoConfig } from "./types";

// Client-side utilities for demo mode (used by demo banner)

function parseCookies(cookieString: string): Record<string, string> {
  const cookies: Record<string, string> = {};
  if (!cookieString) return cookies;

  cookieString.split(";").forEach((cookie) => {
    const [name, value] = cookie.trim().split("=");
    if (name && value) {
      cookies[name] = value;
    }
  });

  return cookies;
}

export const DemoStorage = {
  // Get demo config from cookies
  getConfig(): DemoConfig | null {
    if (typeof window === "undefined") return null;

    const cookies = parseCookies(document.cookie);
    const demoMode = cookies["demo_mode"];

    if (!demoMode) return null;

    try {
      const decoded = decodeURIComponent(demoMode);
      return JSON.parse(decoded);
    } catch {
      return null;
    }
  },

  // Clear all demo cookies
  clearAll(): void {
    clearDemoMode();
  },
};
